module.exports = __webpack_public_path__ + "static/media/boys.bdd33f9b.jpg";